import { useQuery } from "@tanstack/react-query";
import {
	type GetReturnedRollsParams,
	getReturnedRollsData,
} from "../repositories/ReturnedRollsRepository";

type UseReturnedRollsParams = Omit<GetReturnedRollsParams, "signal">;

export const useReturnedRolls = ({ start, end }: UseReturnedRollsParams) => {
	return useQuery({
		queryKey: ["returnedRolls", start, end],
		queryFn: ({ signal }) => getReturnedRollsData({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
